import { render, staticRenderFns } from "./pharmacovigilance.vue?vue&type=template&id=10c5363d&scoped=true"
import script from "./pharmacovigilance.vue?vue&type=script&lang=js"
export * from "./pharmacovigilance.vue?vue&type=script&lang=js"
import style0 from "./pharmacovigilance.vue?vue&type=style&index=0&id=10c5363d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5363d",
  null
  
)

export default component.exports